import { SlotWebSocketClient } from "./slotWebSocketClient";

/**
 * WebSocket 연결 상태 모니터링 서비스
 */
export class PingPongService {
  private pingIntervalId?: ReturnType<typeof setInterval>;
  private readonly pingInterval: number = 5000; // 5초마다 PING
  private readonly pingTimeout: number;

  /**
   * @param webSocket WebSocket 클라이언트
   * @param pingTimeout 타임아웃 (기본: 10초)
   */
  constructor(
    private webSocket: SlotWebSocketClient,
    pingTimeout: number = 10000
  ) {
    this.pingTimeout = pingTimeout;
    this.startPingInterval();
  }

  /**
   * PING 전송 시작
   */
  public startPingInterval(): void {
    try {
      this.stopPingInterval();
      this.pingIntervalId = setInterval(() => {
        this.sendPing();
      }, this.pingInterval);
    } catch (error) {
      console.error("Failed to start ping interval:", error);
    }
  }

  /**
   * PING 메시지 전송
   */
  public sendPing(): void {
    this.webSocket.ping();
  }

  /**
   * PING 전송 중지
   */
  public stopPingInterval(): void {
    try {
      if (this.pingIntervalId) {
        clearInterval(this.pingIntervalId);
        this.pingIntervalId = undefined;
      }
    } catch (error) {
      console.error("Failed to stop ping interval:", error);
    }
  }
}
